"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENCLookup = void 0;
const tslib_1 = require("tslib");
const genc_json_1 = tslib_1.__importDefault(require("../../data/genc.json"));
/**
 * Utility class that takes the 3 digit country code from the symbol ID and returns the 3 character string representation
 * of that country. For example, 840 turns into "USA" for the United States.
 */
class GENCLookup {
    static gencJSON = "/genc.json";
    static _instance;
    static _initCalled = false;
    static _isReady = false;
    static _GENCLookup;
    //private TAG: string = "GENCLookup";
    //private _IDList: Array<string> = new Array<string>();
    static genc;
    /*public static async loadData(location?:string)
    {
        let path:string = GENCLookup.gencJSON;//String(genc);
        if(location)
        {
            path = location + path.substring(path.lastIndexOf('/')+1,path.length);
        }
        RendererUtilities.getData(path).then(result => {this.genc = result;}).catch((err) => {ErrorLogger.LogException("GENCLookup","loadData",err)});
        //RendererUtilities.getData(String(genc)).then(result => {this.genc = result;});
    }//*/
    /**
     *
     * @param url
     * @deprecated
     */
    static async setData(url) {
        //RendererUtilities.getData(url).then(result => {this.genc = result;}).catch((err) => {ErrorLogger.LogException("GENCLookup","loadData",err)});
    }
    /*public static setDataObject()
    {
        this.genc = json;
    }//*/
    constructor() {
        this.init();
    }
    static getInstance() {
        if (!GENCLookup._instance) {
            GENCLookup._instance = new GENCLookup();
        }
        return GENCLookup._instance;
    }
    isReady() {
        return GENCLookup._isReady;
    }
    init() {
        if (typeof genc_json_1.default === 'object') {
            GENCLookup.genc = genc_json_1.default;
        }
        if (GENCLookup._initCalled === false) {
            GENCLookup._initCalled = true;
            GENCLookup._GENCLookup = new Map();
            try {
                let gencJSON = GENCLookup.genc["genc"]["countries"];
                for (let countryJSON of gencJSON) {
                    GENCLookup._GENCLookup.set(countryJSON["numeric"], countryJSON["3char"]);
                }
            }
            catch (e) {
                if (console)
                    console.log(e.message);
                else
                    throw e;
            }
        }
        if (GENCLookup._GENCLookup && GENCLookup._GENCLookup.size > 0)
            GENCLookup._isReady = true;
    }
    get3CharCode(id) {
        if (GENCLookup._GENCLookup && GENCLookup._GENCLookup.has(String(id))) {
            return GENCLookup._GENCLookup.get(String(id));
        }
        return "";
    }
}
exports.GENCLookup = GENCLookup;
//# sourceMappingURL=GENCLookup.js.map